module.exports = __webpack_public_path__ + "img/screen-img-02.8e84394f.jpeg";